import React, { PureComponent } from 'react';
import {  Icon } from 'appSrc/components/UI';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';
import style from './styles/style.module.css';

import 'react-datepicker/dist/react-datepicker.css';


class ScheduleCard extends PureComponent {
    render() {
        const { schedule } = this.props;
        const runDate = moment.utc( schedule.run_date, 'MM/DD/YYYY' );

        return (
            <Link to={ `/admin/dltv/schedules/${ schedule.id }` } key={ runDate.valueOf() } className={ style.scheduleBlock } data-published={ schedule.published }>
                { runDate.format( 'dddd,' ) }<br/>{ runDate.format( 'MM-DD-YYYY' ) }
                { schedule.errorsPresent &&
                    <div className={ style.errorsPresent } title='Errors Present in Schedule'>
                        <Icon source='fontAwesome' icon='fas/faExclamationTriangle' />
                    </div>
                }
            </Link>
        );
    }
}

export default ScheduleCard;
